import { ReactNode, createContext } from "react";
import useUserType, { UserType } from "./hooks/useUserType";

interface UserTypeContextProviderProps {
  children: ReactNode;
}

export interface UserTypeContextData {
  createUsers: (Users: UserType) => void;
  getUsersById: (UserId: string, suppressErrorToast?: boolean) => any;
  validateEmail: (email: string) => any;
  updateUsers: () => any;
  formValuesUsers: UserType;
  setFormValuesUsers: any;
  getUserIp: () => any;
  ipUser: string;
}

const initialState: UserTypeContextData = {
  createUsers() {},
  updateUsers() {},
  getUsersById(UserId: string) {},
  formValuesUsers: {
    name: "",
    email: "",
    password: "",
    nationalRegisterCode: "",
    phone: "",
    address: {
      street: "",
      addtionalData: "",
      district: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
    },
  },
  setFormValuesUsers() {},
  getUserIp() {},
  ipUser: "",
  validateEmail(email: string){}
};

export const UserTypeContext = createContext<UserTypeContextData>(initialState);

export default function UserTypeContextProvider({
  children,
}: UserTypeContextProviderProps) {
  const {
    createUsers,
    formValuesUsers,
    setFormValuesUsers,
    getUsersById,
    updateUsers,
    getUserIp,
    ipUser,
    validateEmail
  } = useUserType();

  return (
    <UserTypeContext.Provider
      value={{
        createUsers,
        formValuesUsers,
        setFormValuesUsers,
        getUsersById,
        updateUsers,
        getUserIp,
        ipUser,
        validateEmail
      }}
    >
      {children}
    </UserTypeContext.Provider>
  );
}
